/**
 * Estimate reading time in minutes for HTML or plain text content.
 * Defaults to 200 words per minute (standard French/English prose).
 */
export const estimateReadingTime = (html, wpm = 200) => {
  if (!html) return 1;
  const text = String(html).replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  if (!text) return 1;
  const words = text.split(" ").filter(Boolean).length;
  return Math.max(1, Math.ceil(words / wpm));
};

export const formatReadingTime = (html, wpm = 200) => {
  const n = estimateReadingTime(html, wpm);
  return `${n} min`;
};
